require "./src/loading/loading_script.js"
